import { AppBar, Box, Button, Dialog, IconButton, Tab, Tabs, Toolbar, Typography } from '@mui/material'
import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';
import { useState } from 'react';
import { useMemo } from 'react';
import { useEffect } from 'react';
import MapEditor from './MapEditor';
import { useYObject } from '../../../hooks/documentHooks';

const BodyContainer = styled('div')`
  position: relative;
  height: calc(100vh - 64px);
  overflow: hidden;
`

const appBarStyle = { position: 'relative' }
const titleStyle = { ml: 2, flex: 1 }
const tabsContainerStyle = { borderBottom: 1, borderColor: 'divider' }

const InteractiveMapEditor = () => {
  const yData = useSelector(state => state.customEditor?.editor === 'interactive-map-editor' && state.customEditor.data)
  const data = useYObject(yData)
  const isOpen = !!data
  const maps = useYObject(yData && (yData.get('maps') || yData.get('maquettes')))
  const mapNames = useMemo(() => maps && Object.keys(maps), [maps])
  const [selectedMap, setSelectedMap] = useState(mapNames && mapNames[0])
  const dispatch = useDispatch()

  const onClose = useCallback(() => {
    dispatch({
      type: 'custom-editor',
      editor: null,
      data: null
    })
  }, [dispatch])

  const handleChangeMap = useCallback((_event, selection) => setSelectedMap(selection), [])

  useEffect(() => {
    if (!selectedMap && mapNames?.length > 0) setSelectedMap(mapNames[0])
  }, [mapNames, selectedMap])

  return (
    <Dialog
      fullScreen
      open={isOpen}
      onClose={onClose}
    >
      <AppBar sx={appBarStyle}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={titleStyle} variant="h6" component="div">
            Interactive Map Editor
          </Typography>
          <Button autoFocus color="inherit" onClick={onClose}>
            Close
          </Button>
        </Toolbar>
      </AppBar>
      <BodyContainer>
        {selectedMap &&
          <>
            <Box sx={tabsContainerStyle}>
              <Tabs value={selectedMap} onChange={handleChangeMap}>
                {mapNames && mapNames.map(mapName => <Tab key={mapName} label={mapName} value={mapName} />)}
              </Tabs>
            </Box>
            {maps && maps[selectedMap] && <MapEditor mapName={selectedMap} mapObject={maps[selectedMap]} />}
          </>
        }
      </BodyContainer>
    </Dialog>
  )
}

export default InteractiveMapEditor